function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import { isBrowser } from "@thebouqs/utils";
import { useMultiStyleConfig } from "@thebouqs/system";
import { CloseIcon } from "@thebouqs/icons";
import { IconButton } from "@thebouqs/button";
import ModalMain from "./ModalMain";
import useModal from "./Modal.hooks/useModal";
export var ModalCloseButton = _ref => {
  var {
    variant,
    size,
    onClick,
    label,
    testid,
    className,
    stylesOverride
  } = _ref;
  var styles = useMultiStyleConfig("Modal", {
    closeButtonVariant: variant
  });
  return /*#__PURE__*/React.createElement(IconButton, {
    colorScheme: "white",
    "aria-label": label,
    sx: _extends({}, styles.closeButton, stylesOverride),
    size: size,
    onClick: onClick,
    fontWeight: "bold",
    variant: "unstyled",
    icon: /*#__PURE__*/React.createElement(CloseIcon, {
      width: "auto",
      maxWidth: "100%"
    }),
    "data-testid": testid,
    className: className
  });
};
ModalCloseButton.defaultProps = {
  testid: "close",
  variant: "normal"
};
export var Modal = _ref2 => {
  var {
    open,
    callback,
    children,
    initialFocusRef,
    finalFocusRef,
    size,
    CloseButton,
    label,
    alignTo,
    stylesOverride
  } = _ref2;

  var _useModal = useModal({
    callback,
    open,
    initialFocusRef,
    finalFocusRef,
    alignTo
  }),
      {
    isOpen,
    onRef: onMainRef
  } = _useModal,
      restProps = _objectWithoutPropertiesLoose(_useModal, ["isOpen", "onRef"]);

  var styles = useMultiStyleConfig("Modal", {
    size,
    alignTo
  }); // JS is disabled or open control is not set

  var controlled = isBrowser && typeof open !== "undefined"; // ModalMain selects how to render the Modal and its wrapper according to the environment and user agent

  return /*#__PURE__*/React.createElement(ModalMain, _extends({
    sx: _extends({}, styles, {
      body: _extends({}, styles.body, stylesOverride == null ? void 0 : stylesOverride.body),
      closeButton: _extends({}, styles.closeButton, stylesOverride == null ? void 0 : stylesOverride.closeButton),
      dialog: _extends({}, styles.dialog, stylesOverride == null ? void 0 : stylesOverride.dialog)
    }),
    ref: onMainRef,
    controlled: controlled,
    open: isOpen,
    CloseButton: CloseButton,
    label: label
  }, restProps), children);
};
Modal.defaultProps = {
  CloseButton: /*#__PURE__*/React.createElement(ModalCloseButton, {
    label: "Close Modal"
  }),
  size: "md"
};
//# sourceMappingURL=Modal.js.map